import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import { emptyObj } from '@beef/utils';
import { Checkbox, PhoneInput } from '@beef/ui-kit';
import { ActionButton } from "./ActionButton";
import styles from "./styles.pcss";
var cx = classnames.bind(styles);
var mask = {
  mask: '_',
  format: '+7 (###) ###-####'
};
export var RenderRequestForm = function RenderRequestForm(_ref) {
  var data = _ref.data,
    isLoading = _ref.isLoading,
    withActionButton = _ref.withActionButton,
    _ref$formId = _ref.formId,
    formId = _ref$formId === void 0 ? 'callback-form' : _ref$formId;
  var phoneInputValue = data.phoneInputValue,
    changePhone = data.changePhone,
    texts = data.texts,
    onBackCallBtnClick = data.onBackCallBtnClick,
    onPhoneFocus = data.onPhoneFocus,
    changeCheckbox = data.changeCheckbox,
    isCheckboxChecked = data.isCheckboxChecked,
    isPersonalVerificationCheckboxEnable = data.isPersonalVerificationCheckboxEnable;
  var redesignPopupTexts = (texts === null || texts === void 0 ? void 0 : texts.redesignPopupTexts) || emptyObj;
  var checkboxText = texts === null || texts === void 0 ? void 0 : texts.userAgreementText;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    inputError = _useState2[0],
    setInputError = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isCheckboxError = _useState4[0],
    setCheckboxError = _useState4[1];
  var validateCtn = function validateCtn() {
    if (phoneInputValue.length !== 10) {
      setInputError(redesignPopupTexts === null || redesignPopupTexts === void 0 ? void 0 : redesignPopupTexts.wrongPhone);
    }
  };
  var handleChangeCheckbox = function handleChangeCheckbox(value) {
    changeCheckbox(value);
    setCheckboxError(isCheckboxChecked);
  };
  var handleSubmit = function handleSubmit(e) {
    e.preventDefault();
    validateCtn();
    setCheckboxError(!isCheckboxChecked);
    onBackCallBtnClick === null || onBackCallBtnClick === void 0 || onBackCallBtnClick();
  };
  var handleChangePhone = function handleChangePhone(e) {
    setInputError('');
    /*
     * в api PhoneInput есть баг, который позволяет вводить номер с +0,
     * для корректной работы валидации +0 добавлена в регулярку
     * */
    changePhone(e.target.value.replace(/\+7|\+0|\D/g, ''));
  };
  return /*#__PURE__*/React.createElement("form", {
    className: cx({
      withActionButton: withActionButton
    }),
    id: formId,
    onSubmit: handleSubmit,
    "data-t-id": "components-RenderRequestForm"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('phoneInputWrapper')
  }, /*#__PURE__*/React.createElement("div", {
    className: "mar-b-m"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('phoneInput')
  }, /*#__PURE__*/React.createElement(PhoneInput, {
    autoComplete: "off",
    errorMessage: inputError,
    maskSettings: mask,
    name: "phone",
    onBlur: validateCtn,
    onChange: handleChangePhone,
    onFocus: onPhoneFocus,
    placeholder: "+7 000 000-00-00",
    type: "tel",
    value: phoneInputValue
  })), withActionButton && /*#__PURE__*/React.createElement("div", {
    className: cx('actionButton')
  }, /*#__PURE__*/React.createElement(ActionButton, {
    buttonText: redesignPopupTexts === null || redesignPopupTexts === void 0 ? void 0 : redesignPopupTexts.backCallBtnText,
    formId: formId,
    isLoading: isLoading,
    tooltipText: redesignPopupTexts === null || redesignPopupTexts === void 0 ? void 0 : redesignPopupTexts.termsOfUse
  }))), isPersonalVerificationCheckboxEnable && /*#__PURE__*/React.createElement(Checkbox, {
    checked: isCheckboxChecked,
    isError: isCheckboxError,
    label: checkboxText,
    name: "selectedAgreement",
    onChange: handleChangeCheckbox
  })));
};
RenderRequestForm.propTypes = process.env.NODE_ENV !== "production" ? {
  data: PropTypes.shape({
    onPhoneFocus: PropTypes.func,
    onBackCallBtnClick: PropTypes.func,
    isCheckboxError: PropTypes.bool,
    isPersonalVerificationCheckboxEnable: PropTypes.bool,
    changeCheckbox: PropTypes.func,
    isCheckboxChecked: PropTypes.bool,
    phoneInputValue: PropTypes.string,
    changePhone: PropTypes.func,
    showCaptcha: PropTypes.bool,
    captchaToken: PropTypes.string,
    // eslint-disable-next-line react/forbid-prop-types
    reCaptchaModel: PropTypes.object,
    phoneInputStatus: PropTypes.string,
    texts: PropTypes.shape({
      redesignPopupTexts: PropTypes.shape({
        phoneLabel: PropTypes.string,
        wrongPhone: PropTypes.string,
        phoneInputDescription: PropTypes.string,
        backCallBtnText: PropTypes.string,
        userAgreementText: PropTypes.string,
        termsOfUse: PropTypes.string
      }),
      userAgreementText: PropTypes.string
    })
  }),
  isLoading: PropTypes.bool,
  withActionButton: PropTypes.bool,
  formId: PropTypes.string
} : {};